import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-monitoramento',
  template: `
  <router-outlet></router-outlet>
`,
})
export class MonitoramentoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
